module.exports = __webpack_public_path__ + "img/vsBombshell2.a14d9dd2.jpg";